export interface Sale {
    id: string;
    date: string;
    items: Array<{
        name: string;
        quantity: number;
        price: number;
        total: number;
    }>;
    totalAmount: number;
}

export interface Purchase {
    id: string;
    date: string;
    items: Array<{
        name: string;
        quantity: number;
        price: number;
        total: number;
    }>;
    totalAmount: number;
}

export interface Supplier {
    id: string;
    name: string;
    status: 'Active' | 'Inactive';
    totalOrders: number;
    totalSpent: number;
    rating: number;
}

// Dummy data
export const salesData: Sale[] = [
    {
        id: '1',
        date: new Date().toISOString(),
        items: [
            { name: 'Laptop Pro', quantity: 5, price: 1200, total: 6000 },
            { name: 'Wireless Mouse', quantity: 10, price: 25, total: 250 }
        ],
        totalAmount: 6250
    },
    {
        id: '2',
        date: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString(),
        items: [
            { name: 'Desktop Ultra', quantity: 3, price: 1500, total: 4500 },
            { name: 'Keyboard Elite', quantity: 8, price: 100, total: 800 }
        ],
        totalAmount: 5300
    },
    {
        id: '3',
        date: new Date().toISOString(),
        items: [
            { name: 'Monitor 4K', quantity: 6, price: 400, total: 2400 },
            { name: 'Laptop Basic', quantity: 4, price: 800, total: 3200 }
        ],
        totalAmount: 5600
    }
];

export const purchaseData: Purchase[] = [
    {
        id: '1',
        date: new Date().toISOString(),
        items: [
            { name: 'Laptop Pro', quantity: 10, price: 1000, total: 10000 },
            { name: 'Wireless Mouse', quantity: 20, price: 20, total: 400 }
        ],
        totalAmount: 10400
    }
];

export const supplierData: Supplier[] = [
    {
        id: '1',
        name: 'TechSupply Pro',
        status: 'Active',
        totalOrders: 150,
        totalSpent: 250000,
        rating: 4.8
    },
    {
        id: '2',
        name: 'Global Electronics',
        status: 'Active',
        totalOrders: 120,
        totalSpent: 180000,
        rating: 4.5
    },
    {
        id: '3',
        name: 'Digital Solutions Inc',
        status: 'Inactive',
        totalOrders: 80,
        totalSpent: 120000,
        rating: 3.9
    }
]; 